import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNotify } from '../contexts/NotifyContext';
import { AUTH_ACCESS_COPY, AUTH_ACCESS_FEEDBACK_DELAY_MS } from '../constants/auth';
import { APP_HOME_PATH } from '../constants/home';
import { PUBLIC_PATH } from '../constants/publicPaths';

const ACCESS_PATHS = new Set([
  APP_HOME_PATH, PUBLIC_PATH.LOGIN, PUBLIC_PATH.REGISTER,
  `${PUBLIC_PATH.LOGIN}/verify`, `${PUBLIC_PATH.REGISTER}/verify`,
]);

export default function useAuthAccessFeedback({ pending = false, error = null, denied = false } = {}) {
  const { pathname } = useLocation();
  const { toast } = useNotify();

  useEffect(() => {
    if (!ACCESS_PATHS.has(pathname)) return undefined;
    const message = error || (denied && pathname === APP_HOME_PATH ? AUTH_ACCESS_COPY.sessionExpired : null);
    if (message) {
      toast.error(message);
      return undefined;
    }
    if (!pending) return undefined;
    const timer = setTimeout(() => toast.error(AUTH_ACCESS_COPY.delayed), AUTH_ACCESS_FEEDBACK_DELAY_MS);
    return () => clearTimeout(timer);
  }, [pathname, pending, error, denied, toast]);
}
